import _slicedToArray from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import React from 'react';
import useTemplate from './useTemplate';
import AccountPicker from '../account-picker/AccountPicker';
import { jsx as _jsx } from "react/jsx-runtime";

var TemplateLoader = function TemplateLoader(_ref) {
  var metadataId = _ref.metadataId,
      setMetadataId = _ref.setMetadataId;

  var _useTemplate = useTemplate(metadataId, setMetadataId),
      _useTemplate2 = _slicedToArray(_useTemplate, 5),
      isAccountPickerVisible = _useTemplate2[0],
      onAccountPickerLoaded = _useTemplate2[1],
      onAccountPickerSubmit = _useTemplate2[2],
      onAccountPickerCancel = _useTemplate2[3],
      onAccountPickerError = _useTemplate2[4];

  return metadataId ? /*#__PURE__*/_jsx(AccountPicker, {
    isVisible: isAccountPickerVisible,
    onLoaded: onAccountPickerLoaded,
    onSubmit: onAccountPickerSubmit,
    onCancel: onAccountPickerCancel,
    onError: onAccountPickerError
  }) : null;
};

export default TemplateLoader;